/* eslint-disable */
import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';
import Spline from '../spline.js';
import InputConnector from '../inputConnector.js';

export default class NodeJoinCurves extends Node
{
	static ATTACHMENT_CHOICES =
	[
		{key: 'start', label: 'Start'},
		{key: 'end', label: 'End'},
	];

	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.BOOLEAN, 'is_closed', false);
		this.addInput(PARAM_TYPE.BOOLEAN, 'connect_in_place', false);		
		this.addInput(PARAM_TYPE.INTEGER, 'num_curves', 2, { minValue: 2, maxValue: 10 });

		this.onInputChangedSubclass('num_curves');

		this.addOutput(PARAM_TYPE.SPLINE, 'spline');
	}

	getType()
	{
		return 'joinCurves';
	}

	getRefreshEnableStatusAfterParamChange(strInputName)
	{
		return strInputName == 'num_curves';
	}

	onInputChangedSubclass(strInputName)
	{
		if(strInputName !== 'num_curves')
			return;

		// Update our connectors:
		let pInput;
		let pNewInputs = [ this.getInput('num_curves'), this.getInput('is_closed'), this.getInput('connect_in_place') ];
		for(let idx = 0; idx < this.getLastInputResult('num_curves'); idx++)
		{
			pInput = new InputConnector(PARAM_TYPE.SPLINE, `spline${idx + 1}`, null, null, {});
			pNewInputs.push(pInput);

			if(idx > 0)
			{
				pInput = new InputConnector(PARAM_TYPE.DROPDOWN, `prev_attach_point${idx + 1}`, null, NodeJoinCurves.ATTACHMENT_CHOICES[1].key, { dropdownOptions: NodeJoinCurves.ATTACHMENT_CHOICES });
				pNewInputs.push(pInput);

				pInput = new InputConnector(PARAM_TYPE.DROPDOWN, `self_attach_point${idx + 1}`, null, NodeJoinCurves.ATTACHMENT_CHOICES[0].key, { dropdownOptions: NodeJoinCurves.ATTACHMENT_CHOICES });
				pNewInputs.push(pInput);
			}
		}
		this.updateInputsOutputs(pNewInputs);
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let pResSpline = null;
		for(let iCurve = 0; iCurve < inputValues['num_curves']; iCurve++)
		{
			// Create a spline from the current input:
			const pCurveData = inputValues[`spline${iCurve + 1}`];
			if(!pCurveData)
				continue;

			let pCurrSpline = new Spline(pCurveData);
			if(!pResSpline)
			{
				pResSpline = pCurrSpline;
				continue;
			}

			// Otherwise, attach at the correct point:
			const bAttachToPrevEnd = inputValues[`prev_attach_point${iCurve + 1}`] == NodeJoinCurves.ATTACHMENT_CHOICES[1].key;
			const bAttachToSelfEnd = inputValues[`self_attach_point${iCurve + 1}`] == NodeJoinCurves.ATTACHMENT_CHOICES[1].key;
			pResSpline.attach(pCurrSpline, bAttachToPrevEnd, bAttachToSelfEnd, inputValues['connect_in_place'], inputValues['connect_in_place']);
		}

		if(pResSpline)
			pResSpline.setIsClosed(inputValues['is_closed']);

		return pResSpline ? pResSpline.saveToObject() : null;
	}
}